import React, { useEffect, useState } from 'react'
import useIsMobile from '../../hooks/useIsMobile'
import Modal from '../Modal'
import { ButtonsContainer, ComponentContainer } from '../Modal/styled'
import { FormContainer, FormSubtitleBold } from '../ui/form'
import { Close } from '../../assets/icons'
import RadioButtonList from '../ui/radioButton'
import { Divider, FormSection } from '../ui/form/styled'

import Input from '../ui/input'
import { Button } from '../ui/button'
import { formatDateInput } from '../../utils/formatDate'
import { Text2 } from '../ui/text'
import theme from '../../styled/theme'
import MultiSelect from '../ui/multiSelect'

const sortOptions = [
	{ id: null, label: 'Fecha' },
	{ id: 'clinica', label: 'Clínica' },
	{ id: 'nroOrden', label: 'Número de orden' }
]

const ModalFilter = ({ showModal, onClose, onApplyFilters, clinics = [], initialFilters }) => {
	const isMobile = useIsMobile()
	const [sortBy, setSortBy] = useState(null)
	const [selectedClinics, setSelectedClinics] = useState([])
	const [filterDate, setFilterDate] = useState('')
	const [orderNumber, setOrderNumber] = useState(null)

	const clinicsOptions = clinics.map(clinic => ({
		value: `${clinic.id}`,
		label: clinic.nombre || clinic.clinicName
	}))

	useEffect(() => {
		if (showModal) {
			setSortBy(initialFilters?.sortBy || null)
			setSelectedClinics(initialFilters?.clinic || [])
			setFilterDate(initialFilters?.fecha || '')
			setOrderNumber(initialFilters?.order || null)
		}
	}, [showModal])

	const handleApplyFilters = () => {
		const filters = {
			sortBy,
			clinic: selectedClinics,
			fecha: filterDate,
			order: orderNumber
		}
		if (typeof onApplyFilters === 'function') {
			onApplyFilters(filters)
		}
		if (onClose) onClose()
	}

	if (!showModal) return null

	return (
		<Modal isFullHeight={isMobile}>
			<ComponentContainer isFullHeight={isMobile}>
				<div onClick={onClose}>
					<Close />
				</div>
				<FormContainer align="center" justifyMobile="start">
					<FormSection>
						<FormSubtitleBold align="left" font="24">
							{isMobile ? 'Filtros' : 'Ordenar'}
						</FormSubtitleBold>
						{isMobile && (
							<Text2 fontWeight={600} color={theme.colors.text.primaryText}>
								Ordenar por
							</Text2>
						)}
						<RadioButtonList options={sortOptions} selected={sortBy} onChange={setSortBy} />
					</FormSection>
					<Divider />
					<FormSection mb={16}>
						{!isMobile && (
							<FormSubtitleBold align="left" font="24">
								Filtrar
							</FormSubtitleBold>
						)}
						<MultiSelect
							padding="10px"
							label="Filtrar por clínica"
							name="clinic"
							value={selectedClinics}
							onChange={e => {
								const newValues = e?.target?.value ?? e?.value ?? e
								setSelectedClinics(Array.isArray(newValues) ? newValues : [])
							}}
							options={clinicsOptions}
							placeholder="Seleccioná una clínica"
						/>
						<Input
							fullWidth
							label="Filtrar por fecha"
							placeholder="Ingresá la fecha de tu informe"
							value={filterDate}
							onChange={e => {
								const formatted = formatDateInput(e.target.value)
								setFilterDate(formatted)
							}}
							inputMode="numeric"
							pattern="\d*"
							maxLength={10}
						/>
						<Input
							fullWidth
							label="Filtrar por número de orden"
							placeholder="Ingresá tu número de orden"
							value={orderNumber}
							onChange={e => {
								const value = e.target.value
								if (/^\d*$/.test(value)) {
									setOrderNumber(value)
								}
							}}
							inputMode="numeric"
							pattern="[0-9]*"
						/>
					</FormSection>
				</FormContainer>
				<ButtonsContainer>
					<Button label="Aplicar filtros" $variant="primary" onClick={() => handleApplyFilters()} />
				</ButtonsContainer>
			</ComponentContainer>
		</Modal>
	)
}

export default ModalFilter
